var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"currentStep":_vm.currentStep,"changeStep":_vm.changeStep,"selectedTab":_vm.selectedTab,"selectTab":_vm.selectTab,"tabs":_vm.tabs,"anonimStepsLength":_vm.anonimStepsLength,"stepsLength":_vm.stepsLength})],2)}
var staticRenderFns = []

export { render, staticRenderFns }